module.exports = __webpack_public_path__ + "static/strategy-dc3ebe9c0721d772eb926462c532a0a8.pdf";